export default __webpack_public_path__ + "static/media/WhatssApp.19715b74.JPG";